"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmojiPickerSearchAndClear = EmojiPickerSearchAndClear;
var _cn = require("@udecode/cn");
var _lucideReact = require("lucide-react");
var _button = require("./button");
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function EmojiPickerSearchAndClear(_ref) {
  var clearSearch = _ref.clearSearch,
    i18n = _ref.i18n,
    searchValue = _ref.searchValue;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex items-center",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _cn.cn)('absolute left-3 top-1/2 z-10 flex size-5 -translate-y-1/2 items-center justify-center'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.SearchIcon, {
        className: "size-4"
      })
    }), searchValue && /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      "aria-label": "Clear",
      className: (0, _cn.cn)('absolute right-1 top-1/2 flex size-8 -translate-y-1/2 cursor-pointer items-center justify-center border-none bg-transparent'),
      onClick: clearSearch,
      size: "icon",
      title: i18n.clear,
      type: "button",
      variant: "ghost",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.DeleteIcon, {
        className: "size-4"
      })
    })]
  });
}